module.exports = __webpack_public_path__ + "static/Wawa.10f25099.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/commercial_logos/Wawa.png
// module id = 2166
// module chunks = 61762850755587